import { taxDocuments } from '../../components/loan_application/form_models/loanFormModel';
import { defaultApplicantName } from '../../constants';
import { ValidationSchema } from '../interfaces';
import FileNameValidationSchema from '../FileNameValidationSchema';
import { Validation } from '../Validation';
import { IrsSS4Ruleset } from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/ruleset';
import { RulesetResult } from '../../pages/dashboard/loan_detail/flows/NewWelcomeFlow/business/rules';

const { irsFormSS4 } = taxDocuments;

export class IrsFormSS4Validation implements ValidationSchema {
  public name = irsFormSS4.name;
  public label = irsFormSS4.getLabel(defaultApplicantName);
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
  public ruleset = IrsSS4Ruleset;

  public when(schema, context, result: RulesetResult) {
    return FileNameValidationSchema(
      irsFormSS4.name,
      !!(result & RulesetResult.REQUIRED)
    );
  }
}
export default new Validation(new IrsFormSS4Validation());
